<div class="offers-table">

    <div class="offers-table__header-wrapper">
        <div class="offers-table__header">
            <div *ngFor="let column of columns"
                 class="offers-table__header__cell">
                <app-offers-table-header-cell   [config]="column"
                                                [sortActive]="offersTableService.isSortActive(column.key)"
                                                [sortOrder]="offersTableService.getSortOrder(column.key)"
                                                (sortUpdate)="onSortUpdate($event)">
                </app-offers-table-header-cell>
            </div>
        </div>
    </div>

    <div class="offers-table__content">
        <div *ngFor="let icOffersData of offersData"
             class="offers-table__row">
            <app-offers-table-row [data]="icOffersData"></app-offers-table-row>
        </div>
    </div>
</div>
